import { render, staticRenderFns } from "./calendar-component.vue?vue&type=template&id=141cc852&scoped=true"
import script from "./calendar-component.vue?vue&type=script&lang=js"
export * from "./calendar-component.vue?vue&type=script&lang=js"
import style0 from "./calendar-component.vue?vue&type=style&index=0&id=141cc852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141cc852",
  null
  
)

export default component.exports